import { DataAttributeDefinitions } from 'scrivito'

import { pisaContactProjectRelationDataClass } from './Pisa/pisaContactProjectRelationDataClass'

const attributes: DataAttributeDefinitions = {}

export const ContactProjectRelation =
  pisaContactProjectRelationDataClass(attributes)
